class MassSchedules {
	constructor() {
		this.form = document.querySelector('#mass-schedules-filter-form');

		if (!this.form) {
			return;
		}

		this.handleFormSubmit();
		this.handleCityChange();
		this.handleRegionChange();
		this.handleSectorPreselect();
		this.handleClearFilters();
		this.handlePagination();
	}

	activeLoader() {
		const loader = document.querySelector('#mass-schedules-loader');
		if (loader) {
			loader.classList.remove('hidden');
		}

		const fields = this.form.querySelectorAll('input, button, select');
		fields.forEach(field => field.setAttribute('disabled', 'true'));
	}

	handleFormSubmit() {
		this.form.addEventListener('submit', (event) => {
			event.preventDefault();

			const url = new URL(window.location.href);
			const fields = ['city', 'neighborhood', 'weekday', 'period', 'region', 'setor'];

			fields.forEach(field => url.searchParams.delete(field));

			const formData = new FormData(this.form);
			formData.forEach((value, key) => {
				if (value !== '' && value !== null) {
					url.searchParams.set(key, value);
				}
			});

			this.activeLoader();
			location.replace(url.toString());
		});
	}

	handleCityChange() {
		const citySelect = document.querySelector('#mass-schedules-city');

		if (!citySelect) {
			return;
		}

		citySelect.addEventListener('change', () => {
			const url = new URL(window.location.href);
			url.searchParams.delete('neighborhood');

			if (citySelect.value) {
				url.searchParams.set('city', citySelect.value);
			} else {
				url.searchParams.delete('city');
			}

			this.activeLoader();
			location.replace(url.toString());
		});
	}

	handleRegionChange() {
		const regionSelect = document.querySelector('#mass-schedules-region');

		if (!regionSelect) {
			return;
		}

		regionSelect.addEventListener('change', () => {
			this.populateSectors(regionSelect);
		});
	}

	handleSectorPreselect() {
		const regionSelect = document.querySelector('#mass-schedules-region');
		if (regionSelect) {
			this.populateSectors(regionSelect);
		}
	}

	populateSectors(regionSelect) {
		const sectorSelect = document.querySelector('#mass-schedules-sector');
		if (!sectorSelect) return;

		const currentSector = sectorSelect.getAttribute('data-sector');
		const sectorLabel = sectorSelect.getAttribute('data-sector-label') || 'Setor';
		const selectedOption = regionSelect.options[regionSelect.selectedIndex];
		const raw = selectedOption?.getAttribute('data-item');

		sectorSelect.innerHTML = `<option value="">Selecione um ${sectorLabel}</option>`;

		if (!raw) {
			return;
		}

		let data;
		try {
			data = JSON.parse(raw);
		} catch (error) {
			return;
		}

		if (!data.sectors) return;

		data.sectors.forEach(sector => {
			const option = document.createElement('option');
			option.value = sector.id;
			option.innerText = sector.name;

			if (currentSector && currentSector == sector.id) {
				option.selected = true;
			}

			sectorSelect.appendChild(option);
		});
	}

	handleClearFilters() {
		const button = document.querySelector('#mass-schedules-clear');

		if (!button) {
			return;
		}

		button.addEventListener('click', () => {
			const url = new URL(window.location.href);
			['city', 'neighborhood', 'weekday', 'period', 'region', 'setor'].forEach(field => {
				url.searchParams.delete(field);
			});

			this.activeLoader();
			location.replace(url.toString());
		});
	}

	handlePagination() {
		const paginationItems = document.querySelectorAll('#mass-schedules-pagination .pagination-item');

		paginationItems.forEach(item => {
			const page = item.getAttribute('data-page');
			if (!page) return;

			const url = new URL(window.location.href);
			item.href = `${item.href}page/${page}/?${url.searchParams.toString()}`;
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new MassSchedules();
});
